var _desc, _style, _circle, _ellipse, _rect, _rect2, _path, _path2, _path3, _rect3, _rect4, _rect5, _path4, _circle2, _circle3, _circle4, _rect6, _rect7, _rect8, _g, _path5, _path6, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 200",
    width: 240,
    height: 200,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-report-title"
  }, "Ei viel\xE4 raportteja") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "empty-report-title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "empty-report-desc"
  }, "Paperipino, jonka p\xE4\xE4llimm\xE4isess\xE4 raportissa on tyhj\xE4 kaavioalue ja kyn\xE4")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .empty-report-accent { fill: var(--empty-accent, #6366f1); }\n    .empty-report-stroke { stroke: var(--empty-accent, #6366f1); }\n    .empty-report-muted  { fill: var(--empty-muted, #e0e7ff); }\n    .empty-report-surface{ fill: var(--empty-surface, #ffffff); }\n    .empty-report-line   { stroke: var(--empty-line, #c7d2fe); }\n    .empty-report-pen    { animation: empty-report-pen 4s ease-in-out 2; }\n    @keyframes empty-report-pen     { 0%,100% { transform: translate(0,0) rotate(0); } 50% { transform: translate(-6px,4px); } }\n    @media (prefers-reduced-motion: reduce) { .empty-report-pen { animation: none; } }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 104,
    r: 86,
    className: "empty-report-muted",
    opacity: 0.55
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 172,
    rx: 58,
    ry: 6,
    className: "empty-report-accent",
    opacity: 0.12
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 40,
    width: 92,
    height: 120,
    rx: 8,
    className: "empty-report-surface empty-report-line",
    strokeWidth: 2,
    transform: "rotate(-8 116 100)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 38,
    width: 92,
    height: 120,
    rx: 8,
    className: "empty-report-surface empty-report-line",
    strokeWidth: 2,
    transform: "rotate(5 118 98)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 46 a8 8 0 0 1 8 -8 H142 L162 58 V158 a8 8 0 0 1 -8 8 H78 a8 8 0 0 1 -8 -8 Z",
    className: "empty-report-surface empty-report-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142 38 V52 a6 6 0 0 0 6 6 H162 Z",
    className: "empty-report-accent",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142 38 V52 a6 6 0 0 0 6 6 H162",
    fill: "none",
    className: "empty-report-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 52,
    width: 40,
    height: 6,
    rx: 3,
    className: "empty-report-accent",
    opacity: 0.45
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 63,
    width: 26,
    height: 4,
    rx: 2,
    className: "empty-report-line",
    fill: "var(--empty-line, #c7d2fe)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 76,
    width: 68,
    height: 38,
    rx: 5,
    fill: "none",
    className: "empty-report-line",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 106 V84 M90 106 H142",
    fill: "none",
    className: "empty-report-line",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 95,
    r: 2.4,
    className: "empty-report-accent",
    opacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 95,
    r: 2.4,
    className: "empty-report-accent",
    opacity: 0.35
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 95,
    r: 2.4,
    className: "empty-report-accent",
    opacity: 0.35
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-report-write",
    x: 82,
    y: 124,
    width: 68,
    height: 4,
    rx: 2,
    fill: "var(--empty-line, #c7d2fe)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-report-write empty-report-b",
    x: 82,
    y: 134,
    width: 56,
    height: 4,
    rx: 2,
    fill: "var(--empty-line, #c7d2fe)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "empty-report-write empty-report-c",
    x: 82,
    y: 144,
    width: 40,
    height: 4,
    rx: 2,
    fill: "var(--empty-line, #c7d2fe)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "empty-report-pen"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40 176 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 96,
    width: 12,
    height: 44,
    rx: 2,
    className: "empty-report-surface empty-report-stroke",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 96,
    width: 12,
    height: 9,
    rx: 2,
    className: "empty-report-accent",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 140 H182 L176 152 Z",
    className: "empty-report-surface empty-report-stroke",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 148 H178 L176 152 Z",
    className: "empty-report-accent"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "empty-report-accent empty-report-twinkle",
    d: "M44 62 l2.2 5.8 5.8 2.2 -5.8 2.2 -2.2 5.8 -2.2 -5.8 -5.8 -2.2 5.8 -2.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "empty-report-accent empty-report-twinkle empty-report-b",
    d: "M196 46 l1.8 4.5 4.5 1.8 -4.5 1.8 -1.8 4.5 -1.8 -4.5 -4.5 -1.8 4.5 -1.8z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 140,
    r: 3,
    className: "empty-report-accent",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReport);
export default __webpack_public_path__ + "static/media/empty-report.fa8bc692af119fd168c7e8ef72424314.svg";
export { ForwardRef as ReactComponent };